angular.module('app').directive('uiCan', [
    function() {
        return {
            restrict: 'E',
            scope: {
                details: '=details',
                others: '=others',
                object: '=object',
            },
            link: function() {},
            templateUrl: 'tpl/can-detail.html?cache=2',
        };
    },
]);
